import { Button } from '../../../components/ui/button';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
  AlertDialogTrigger,
} from '../../../components/ui/alert-dialog';
import { Truck, Upload, Download, Plus, Loader2, RefreshCw } from 'lucide-react';

export function RoutesHeader({
  onImport,
  onExport,
  onAdd,
  onRecalculate,
  exporting,
  recalculating,
  t,
  userRole
}) {
  const canRecalc = ['SUPER_ADMIN', 'FULL_ADMIN', 'FIRM_ADMIN'].includes(userRole);
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
      <div>
        <h1 className="text-2xl font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
          <Truck className="h-7 w-7 text-blue-600" />
          {t('routes.title') || 'Routelar / Turlar'}
        </h1>
        <p className="text-slate-500 dark:text-slate-400 mt-1 text-sm">{t('routes.description') || 'Günlük route ve tur verilerini yönetin'}</p>
      </div>
      <div className="flex flex-wrap gap-2">
        {canRecalc && (
          <AlertDialog>
            <AlertDialogTrigger asChild>
              <Button
                variant="outline"
                size="sm"
                className="text-amber-700 border-amber-300 hover:bg-amber-50"
                disabled={recalculating}
                data-testid="recalculate-btn"
                title={t('routes.recalculate') || 'Tüm Route\'ları Yeniden Hesapla'}
              >
                {recalculating ? <Loader2 className="h-4 w-4 sm:mr-2 animate-spin" /> : <RefreshCw className="h-4 w-4 sm:mr-2" />}
                <span className="hidden sm:inline">{t('routes.recalculate') || 'Yeniden Hesapla'}</span>
              </Button>
            </AlertDialogTrigger>
            <AlertDialogContent>
              <AlertDialogHeader>
                <AlertDialogTitle>{t('routes.recalculateTitle') || 'Tüm Route\'ları Yeniden Hesapla'}</AlertDialogTitle>
                <AlertDialogDescription>
                  {t('routes.recalculateBody') || 'Mevcut tüm route kayıtlarının çalışma saati ve toplam tutarları güncel hesaplama kurallarıyla yeniden hesaplanacak. Sabit ücret 0 gibi eski hatalı kayıtlar düzeltilecek. Bu işlem geri alınamaz.'}
                </AlertDialogDescription>
              </AlertDialogHeader>
              <AlertDialogFooter>
                <AlertDialogCancel>{t('common.cancel') || 'İptal'}</AlertDialogCancel>
                <AlertDialogAction onClick={onRecalculate} className="bg-amber-600 hover:bg-amber-700" data-testid="recalculate-confirm">
                  {t('routes.recalculate') || 'Yeniden Hesapla'}
                </AlertDialogAction>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialog>
        )}
        <Button variant="outline" size="sm" onClick={onImport}>
          <Upload className="h-4 w-4 sm:mr-2" />
          <span className="hidden sm:inline">{t('routes.importExcel') || 'Excel Yükle'}</span>
        </Button>
        <Button variant="outline" size="sm" onClick={onExport} disabled={exporting}>
          {exporting ? <Loader2 className="h-4 w-4 sm:mr-2 animate-spin" /> : <Download className="h-4 w-4 sm:mr-2" />}
          <span className="hidden sm:inline">{t('routes.exportExcel') || 'Excel İndir'}</span>
        </Button>
        <Button size="sm" onClick={onAdd}>
          <Plus className="h-4 w-4 sm:mr-2" />
          <span className="hidden sm:inline">{t('routes.newRoute') || 'Yeni Route'}</span>
        </Button>
      </div>
    </div>
  );
}
